import {
  createDashboard,
  CreateDashboardMutation,
  CreateDashboardMutationVariables,
  deleteDashboard,
  DeleteDashboardMutation,
  DeleteDashboardMutationVariables,
  graphqlCall,
  updateDashboard,
  UpdateDashboardMutation,
  UpdateDashboardMutationVariables,
} from '@akin-home/amplify';

export const updateDashboardMutation = (
  params: UpdateDashboardMutationVariables
) => graphqlCall<UpdateDashboardMutation>(updateDashboard, params);

export const createDashboardMutation = (
  params: CreateDashboardMutationVariables
) => graphqlCall<CreateDashboardMutation>(createDashboard, params);

export const deleteDashboardMutation = (
  params: DeleteDashboardMutationVariables
) => graphqlCall<DeleteDashboardMutation>(deleteDashboard, params);
